// extracted by css-extract-rspack-plugin
var _1 = "SpecialtyModSlotIcon-m_specialtyModIcon-fYqVTWi_";
export { _1 as "specialtyModIcon" }
